export function isSameObject(val1,val2) {
	let object1String = JSON.stringify(val1);
	let object2String = JSON.stringify(val2);
	return (object1String === object2String);
}

export function getValueArray(arr){
	return (arr || []).concat();
}

export function getArrayIndex(arr,key,value){
	return arr.findIndex(row=>{
		return row[key] === value;
	})
}

export function getValueHash(hash){
	return JSON.parse(JSON.stringify(hash));
}

export function getArrayFromHash(hash){
	if(!hash){
		return []
	}
	return Object.keys(hash).map(function (key) {return hash[key]});
}


// WEBPACK FOOTER //
// ./src/common/utils/array.js